import React from 'react';
export default function ComeOnLogo(props) {
    return (
        <svg x="0px" y="0px" viewBox="0 0 453.5 75.9" enableBackground="0 0 453.5 75.9" {...props}>
            <g>
                <path
                    fill="#F9F9F9"
                    d="M32.2,26.4c6.2,0,11.6,3.3,14.7,8.2l8.4-13.3c-5.8-6-14-9.8-23.1-9.8C14.4,11.5,0,26,0,43.7
		s14.4,32.2,32.2,32.2c8.9,0,17-3.6,22.8-9.5l-8.4-13.2c-3.1,4.7-8.4,7.8-14.4,7.8c-9.5,0-17.3-7.7-17.3-17.3S22.6,26.4,32.2,26.4z"
                />
                <path
                    fill="#F9F9F9"
                    d="M91.9,11.5c-10.3,0-19.5,4.9-25.4,12.5c-1.8,2.3-3.3,4.9-4.4,7.6c-1.5,3.7-2.3,7.8-2.3,12s0.8,8.3,2.3,12
		c1.1,2.7,2.6,5.3,4.4,7.6c5.9,7.6,15.1,12.5,25.5,12.5c17.7,0,32.2-14.4,32.2-32.2S109.6,11.5,91.9,11.5z M91.9,60.9
		c-4.7,0-8.9-1.9-12-4.9c-3.2-3.1-5.2-7.5-5.2-12.3c0-4.8,1.9-9.1,5.1-12.2c3.1-3.1,7.4-5.1,12.2-5.1c9.5,0,17.3,7.7,17.3,17.3
		S101.4,60.9,91.9,60.9z"
                />
                <path
                    fill="#F9F9F9"
                    d="M287.5,39.4c-0.7-8.1-4.1-15.1-9.8-20.3c-5.5-4.9-12.9-7.6-20.7-7.6c-8.4,0-16.1,3.3-21.9,9.2
		c-5.9,6.1-9.1,14.3-9.1,23.3c0,9.4,3.4,17.5,9.8,23.3c5.9,5.4,14,8.4,22.7,8.4c10.8,0,19.6-3.7,26.1-11l-10.5-9.3
		c-3.8,4.2-9.1,6.3-15.5,6.3c-4,0-8-1.2-11.2-3.3c-3.4-2.2-5.7-5.3-6.8-8.9l-0.1-0.4l46.9,0C287.3,49.4,288,45,287.5,39.4z M257,25
		c4.4,0,8.4,1.5,11.4,4.3c2.4,2.3,4.2,5.4,5,8.8h-33C241.8,31.6,247.8,25,257,25z"
                />
                <path
                    fill="#F9F9F9"
                    d="M191.9,11.9c-6.5,0-12.4,2.5-16.8,6.7c-4.4-4.2-10.3-6.7-16.8-6.7c-13.5,0-24.4,10.9-24.4,24.4v37.7h15.3V60.3
		V36.4v0h0c0-5.1,4.1-9.2,9.2-9.2c5.1,0,9.2,4.1,9.2,9.2h0v0v23.9v13.8h15.3V60.3V36.4v0h0c0-5.1,4.1-9.2,9.2-9.2s9.2,4.1,9.2,9.2h0
		v0v23.9v13.8h15.3V36.4C216.3,22.9,205.4,11.9,191.9,11.9z"
                />
            </g>
            <g>
                <path
                    fill="#8EB50D"
                    d="M398.5,11.5c-15.7,0-28.4,11.5-28.4,27.2v35.4h16.1V39.3c0-6.8,5.5-12.4,12.4-12.4c6.8,0,12.4,5.6,12.4,12.4
		v34.8h16.1V38.7C426.9,23.1,414.2,11.5,398.5,11.5z"
                />
                <path
                    fill="#8EB50D"
                    d="M328.5,11.5c-17.7,0-32.2,14.4-32.2,32.2s14.4,32.2,32.2,32.2c17.7,0,32.2-14.4,32.2-32.2
		S346.2,11.5,328.5,11.5z M328.5,60.9c-9.5,0-17.3-7.7-17.3-17.3s7.7-17.3,17.3-17.3s17.3,7.7,17.3,17.3S338,60.9,328.5,60.9z"
                />
                <g>
                    <rect x="438.5" y="60.1" fill="#8EB50D" width="15" height="14" />
                    <polygon fill="#8EB50D" points="453.1,50.1 439,50.1 438.6,0.4 453.5,0.4 		" />
                </g>
            </g>
        </svg>
    );
}



/** WEBPACK FOOTER **
 ** ../src/widgets/components/ui/svg/comeon.js
 **/